import BaseController from "../baseController";

export class AnswerController {
  urlBase = "/answers";
  
  constructor() {
    this.base = BaseController;
  }

  async getPendingAnswers(profileId) {
    if (typeof profileId !== "string")
      throw new Error("Invalid profile id.");
    return this.base._get(`${this.urlBase}?$filter=profileId eq '${profileId}' and status ne 'finished'`);
  }
  
  async getFinishedAnswers(profileId) {
    if (typeof profileId !== "string")
      throw new Error("Invalid profile id.");
    return this.base._get(`${this.urlBase}?$filter=profileId eq '${profileId}' and status eq 'finished'`);
  }
  
  async sendQuestionAnswer(answerId, questionId, {chosenOptionsIds}) {
    if (typeof answerId !== "string")
      throw new Error("Invalid answerId id.");
    if (typeof questionId !== "number")
      throw new Error("Invalid questionId id.");
    if (!Array.isArray(chosenOptionsIds) || !chosenOptionsIds.every(v => typeof v === "number"))
      throw new Error("Invalid answer format.");
    return this.base._post(`${this.urlBase}/${answerId}/questions/${questionId}`, {
      chosenOptionsIds
    });
  }
}

const answerController = new AnswerController();

export default answerController;